const Footer = (props) => {
    return (
    <footer class="footer">
        <p>&copy; 2024 The Clean Wheels Pvt Ltd. | All rights reserved</p>
    </footer>
    );
};
export default Footer;
    